
import Vue from 'vue'
import Router from 'vue-router'

// Importar las vistas
import chatNewHome from '../views/chatHome.vue'
import chatSession from '../views/chatSession.vue'
import recentChats from '../views/recentChats.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/recentChats/:idChatbot',   //ai.chatpro.us/recentChats
      name: 'recentChats',
      component: recentChats,
    },
    {
      path: '/:idChatbot',   //ai.chatpro.us/:idChatbot
      name: 'chatHome',
      component: chatNewHome,
    },
    {
      path: '/:idChatbot/:idConversation',   //ai.chatpro.us/:idChatbot/:idConversation
      name: 'chatUI',
      component: chatSession,
    }
  ]
});


export default router;